import React from "react";
import Button from "../ui/Button";

interface Props {
  title: string;
  subtitle?: string;
  action?: { label: string; onClick: () => void; icon?: string;disabled?: boolean };
  children: React.ReactNode;
}

const PageShell: React.FC<Props> = ({ title, subtitle, action, children }) => (
  <div className="space-y-6 animate-fade-in">
    <div className="flex items-start justify-between gap-4">
      <div>
        <h1 className="text-2xl font-extrabold text-gray-800 tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-gray-500 mt-0.5">{subtitle}</p>}
      </div>
      {action && (
        <Button onClick={action.onClick}>
          {action.icon ?? "＋"} {action.label}
        </Button>
      )}
    </div>
    {children}
  </div>
);

export default PageShell;
